<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">{{name}}</h1>

                    <a v-if="!isDeleted" @click="invokeTriggerPipelineManuallyCommandV1" role="button" class="btn btn-link btn-sm">
                        <i class="fa fa-bolt" aria-hidden="true"></i>
                        <span>Run pipeline</span>
                    </a>

                    <a v-if="!isDeleted" @click="handleAbortPipelineRunsCommandV1" role="button" class="btn btn-link btn-sm">
                        <i class="fa fa-ban" aria-hidden="true"></i>
                        <span>Abort runs</span>
                    </a>

                    <a v-else @click="handlePermanentDeletePipelineCommandV1" role="button" class="btn btn-link btn-sm">
                        <i class="fa fa-bolt" aria-hidden="true"></i>
                        <span>Delete permanently</span>
                    </a>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                    <div class="dropdown">
                        <button class="btn btn-success dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                            Share
                        </button>
                        <div class="dropdown-menu">
                            <a class="dropdown-item" :href="`/#/sharing/resource/PipelineTriggerDataShareResourceProvider/${id}`">Trigger</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div v-if="!isDeleted" class="container">
            <a :href="`/#/admin/integrations/pipelines/configure/connector/${tid}/${id}`">Configure connector</a>&nbsp;<span>({{connectorName || 'Not configured'}})</span><br />
            <a :href="`/#/admin/integrations/pipelines/configure/dataset/${tid}/${id}`">Configure dataset</a>
            <span>(<a :href="`/#/admin/integrations/datasets/details/${datasetId}`" target="_blank">{{datasetName || 'Not configured'}}</a>)</span><br />
            <a :href="`/#/admin/integrations/pipelines/configure/properties/${tid}/${id}`">Configure properties</a><br />
            <a :href="`/#/admin/integrations/pipelines/configure/mapping/${tid}/${id}`">Configure mappings</a><br />
            <a :href="`/#/admin/integrations/pipelines/configure/ids/${tid}/${id}`">Configure IDs</a><br />
            <br />

            <a :href="`/#/admin/integrations/pipelines/preview/${tid}/${id}`" class="btn btn-primary" role="button">Preview</a>
            <a v-if="connectorProviderReadPageUrl" :href="`${connectorProviderReadPageUrl}${tid}?pipelineId=${id}&connectorId=${connectorId}`" class="btn btn-primary" role="button" target="_blank">Open</a>
            <button @click="invokeActivatePipelineCommandV1" class="btn btn-success" v-if="!isActive">Activate</button>
            <button @click="invokeDeactivatePipelineCommandV1" class="btn btn-warning" v-else>Deactivate</button>
            <button @click="handleDeletePipelineCommandV1" class="btn btn-danger" :disabled="isActive">Delete</button>
            <br />
            <br /><br />

            <div v-if="!connectorOnlyInternalTriggers" class="form-group">

                <div class="form-group">
                    <label for="applyChangesMode">Apply changes mode:</label><br />

                    <div class="form-check form-check-inline">
                        <input v-model="applyChangesMode" class="form-check-input" type="radio" name="applyChangesMode" id="applyChangesModeAllAtOnce" :value="1">
                        <label class="form-check-label" for="applyChangesModeAllAtOnce">All at once</label>
                    </div>

                    <div class="form-check form-check-inline">
                        <input v-model="applyChangesMode" class="form-check-input" type="radio" name="applyChangesMode" id="applyChangesModeOneByOne" :value="2">
                        <label class="form-check-label" for="applyChangesModeOneByOne">One by one</label>
                    </div>

                    <div class="form-check form-check-inline">
                        <input v-model="applyChangesMode" class="form-check-input" type="radio" name="applyChangesMode" id="applyChangesModeGroupByItem" :value="3">
                        <label class="form-check-label" for="applyChangesModeGroupByItem">Group by item</label>
                    </div>

                    <button @click="invokeChangeApplyChangesModeCommandV1" class="btn btn-sm btn-secondary">Update</button>
                </div>

                <div class="form-group">
                    <label for="timeTriggerRecurrency">Time trigger:</label><br />

                    <div class="form-check form-check-inline">
                        <input v-model="timeTriggerRecurrency" class="form-check-input" type="radio" name="timeTriggerRecurrency" id="timeTriggerRecurrencyNone" :value="null">
                        <label class="form-check-label" for="timeTriggerRecurrencyNone">None</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input v-model="timeTriggerRecurrency" class="form-check-input" type="radio" name="timeTriggerRecurrency" id="timeTriggerRecurrency10m" value="00:15:00">
                        <label class="form-check-label" for="timeTriggerRecurrency10m">Every 15 minutes</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input v-model="timeTriggerRecurrency" class="form-check-input" type="radio" name="timeTriggerRecurrency" id="timeTriggerRecurrency10m" value="00:30:00">
                        <label class="form-check-label" for="timeTriggerRecurrency10m">Every 30 minutes</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input v-model="timeTriggerRecurrency" class="form-check-input" type="radio" name="timeTriggerRecurrency" id="timeTriggerRecurrency1h" value="01:00:00">
                        <label class="form-check-label" for="timeTriggerRecurrency1h">Hourly</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input v-model="timeTriggerRecurrency" class="form-check-input" type="radio" name="timeTriggerRecurrency" id="timeTriggerRecurrency1d" value="1.00:00:00">
                        <label class="form-check-label" for="timeTriggerRecurrency1d">Daily</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input v-model="timeTriggerRecurrency" class="form-check-input" type="radio" name="timeTriggerRecurrency" id="timeTriggerRecurrency7d" value="7.00:00:00">
                        <label class="form-check-label" for="timeTriggerRecurrency7d">Weekly</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input v-model="timeTriggerRecurrency" class="form-check-input" type="radio" name="timeTriggerRecurrency" id="timeTriggerRecurrency30d" value="30.00:00:00">
                        <label class="form-check-label" for="timeTriggerRecurrency30d">Every 30 days</label>
                    </div>

                    <button @click="invokeChangePipelineTimeTriggerRecurrencyCommandV1" class="btn btn-sm btn-secondary">Update</button>
                </div>

                <div v-if="!connectorOnlyInternalTriggers" class="form-group">
                    <label for="triggerOnRunCompleted">Pipeline completed trigger:</label><br />

                    <select v-model="triggerOnRunCompleted" class="form-control" id="triggerOnRunCompleted">
                        <option :value="null">None</option>
                        <option v-for="p in otherPipelines" :value="p.PipelineId" :key="p.PipelineId">{{p.Name}}</option>
                    </select>

                    <button @click="invokeChangePipelineTriggerOnRunCompletedCommandV1" class="btn btn-sm btn-secondary">Update</button>
                </div>

                <div v-if="connectorInternalTriggers.length>0" class="form-group">
                    <label for="internalConnectorTrigger">Pipeline connector trigger:</label><br />

                    <select v-model="internalConnectorTrigger" class="form-control" id="internalConnectorTrigger">
                        <option :value="null">None</option>
                        <option v-for="t in connectorInternalTriggers" :value="t.Name" :key="t.Name">{{t.Title}}</option>
                    </select>

                    <button @click="invokeChangePipelineInternalConnectorTriggerCommandV1" class="btn btn-sm btn-secondary">Update</button>

                    <a v-if="selectedConnectorInternalTrigger?.PageUrl" :href="`${selectedConnectorInternalTrigger?.PageUrl}/?pipelineId=${id}&connectorId=${connectorId}`" target="_blank">Open</a>
                </div>
            </div>

            <div v-else class="container">
                <h4>Pipeline was deleted</h4>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, watch, onMounted } from 'vue'
    import { useId, useOrganizationUnitId, useRouter } from '@common/composables'
    import { useAdminPipelineDetailsPage } from '@Integrations/Pipelines/pages-core'

    const router = useRouter()
    const tid = useOrganizationUnitId()
    const id = useId()

    const {
        useCurrentUserQuery,
        usePipelineDetailsQuery,
        useAllPipelinesQuery,
        useActivatePipelineCommand,
        useDeactivatePipelineCommand,
        useTriggerPipelineManuallyCommand,
        useChangePipelineTimeTriggerRecurrencyCommand,
        useChangePipelineTriggerOnRunCompletedCommand,
        useChangePipelineInternalConnectorTriggerCommandV1,
        useChangeApplyChangesModeCommand,
        useResetPipelineRunsCommand,
        useDeletePipelineCommand,
        usePermanentDeletePipelineCommand,
    } = useAdminPipelineDetailsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelAllPipelinesQueryV1, runAllPipelinesQueryV1 } = useAllPipelinesQuery(tid)
    const pipelines = computed(() => modelAllPipelinesQueryV1.value?.Pipelines || [])
    const otherPipelines = computed(() => pipelines.value.filter(p => p.PipelineId != id))

    const { modelPipelineDetailsQueryV1, runPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const name = computed(() => modelPipelineDetailsQueryV1.value?.Name)
    const connectorName = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorProviderName)
    const datasetName = computed(() => modelPipelineDetailsQueryV1.value?.DatasetName)
    const isActive = computed(() => modelPipelineDetailsQueryV1.value?.IsActive)
    const connectorId = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorId)
    const datasetId = computed(() => modelPipelineDetailsQueryV1.value?.DatasetId)
    const isDeleted = computed(() => modelPipelineDetailsQueryV1.value?.IsDeleted)
    const connectorProviderReadPageUrl = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorProviderReadPageUrl)
    const connectorProviderWritePageUrl = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorProviderWritePageUrl)
    const connectorOnlyInternalTriggers = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorOnlyInternalTriggers)
    const connectorInternalTriggers = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorInternalTriggers ?? [])
    const selectedConnectorInternalTrigger = computed(() => connectorInternalTriggers.value.find(t => t.Name == internalConnectorTrigger.value))

    const { invokeActivatePipelineCommandV1, succeed: succeedActivatePipelineCommandV1 } = useActivatePipelineCommand(id, tid, userId)
    const { invokeDeactivatePipelineCommandV1, succeed: succeedDeactivatePipelineCommandV1 } = useDeactivatePipelineCommand(id, tid, userId)

    const { invokeTriggerPipelineManuallyCommandV1, succeedTriggerPipelineManuallyCommandV1 } = useTriggerPipelineManuallyCommand(id, tid, userId)

    const {
        invokeChangePipelineTimeTriggerRecurrencyCommandV1,
        succeedChangePipelineTimeTriggerRecurrencyCommandV1,
        timeTriggerRecurrency
    } = useChangePipelineTimeTriggerRecurrencyCommand(id, tid, userId)

    const {
        invokeChangePipelineTriggerOnRunCompletedCommandV1,
        succeedChangePipelineTriggerOnRunCompletedCommandV1,
        triggerOnRunCompleted
    } = useChangePipelineTriggerOnRunCompletedCommand(id, tid, userId)

    const {
        invokeChangePipelineInternalConnectorTriggerCommandV1,
        succeedChangePipelineInternalConnectorTriggerCommandV1,
        internalConnectorTrigger
    } = useChangePipelineInternalConnectorTriggerCommandV1(id, tid, userId)

    const { invokeChangeApplyChangesModeCommandV1, succeedChangeApplyChangesModeCommandV1, applyChangesMode } = useChangeApplyChangesModeCommand(id, tid, userId)

    const { invokeResetPipelineRunsCommandV1, succeedResetPipelineRunsCommandV1 } = useResetPipelineRunsCommand(id, tid, userId)

    const { invokeDeletePipelineCommandV1, succeedDeletePipelineCommandV1 } = useDeletePipelineCommand(id, tid, userId)
    const { invokePermanentDeletePipelineCommandV1, succeedPermanentDeletePipelineCommandV1 } = usePermanentDeletePipelineCommand(id)

    watch(name, () => document.title = name.value)

    watch([succeedTriggerPipelineManuallyCommandV1, succeedPermanentDeletePipelineCommandV1], (val) => val ? router.push(`/admin/integrations/pipelines/dashboard/${tid}`) : null)

    watch(modelPipelineDetailsQueryV1, () => {
        timeTriggerRecurrency.value = modelPipelineDetailsQueryV1.value?.TimeTriggerRecurrency
        triggerOnRunCompleted.value = modelPipelineDetailsQueryV1.value?.TriggerOnRunCompleted
        internalConnectorTrigger.value = modelPipelineDetailsQueryV1.value?.InternalConnectorTrigger
        applyChangesMode.value = modelPipelineDetailsQueryV1.value?.ApplyChangesMode
    })

    watch([
        succeedActivatePipelineCommandV1,
        succeedDeactivatePipelineCommandV1,
        succeedChangePipelineTimeTriggerRecurrencyCommandV1,
        succeedChangePipelineTriggerOnRunCompletedCommandV1,
        succeedChangePipelineInternalConnectorTriggerCommandV1,
        succeedResetPipelineRunsCommandV1,
        succeedDeletePipelineCommandV1
    ], () => runPipelineDetailsQueryV1())

    onMounted(() => {
        runCurrentUserQueryV1()
        runAllPipelinesQueryV1()
        runPipelineDetailsQueryV1()
    })

    function handleAbortPipelineRunsCommandV1() {
        if (confirm(`Do you really want to abort all runs of pipeline ${name.value}?`)) invokeResetPipelineRunsCommandV1()
    }

    function handleDeletePipelineCommandV1() {
        if (confirm(`Do you really want to delete pipeline ${name.value}?`)) invokeDeletePipelineCommandV1()
    }

    function handlePermanentDeletePipelineCommandV1() {
        if (confirm(`Do you really want to PERMANENTLY delete pipeline ${name.value}?`)) invokePermanentDeletePipelineCommandV1()
    }
</script>
